(function () {
    'use strict';

    angular
        .module('app')
        .controller('CharacterCounterController', CharacterCounterController);

        CharacterCounterController.$inject = ['$http', '$scope'];

    function CharacterCounterController($http, $scope) {
        var CharacterCounter = this;
        CharacterCounter.isMaxExceeded = isMaxExceeded;

        function isMaxExceeded() {
            return CharacterCounter.current > CharacterCounter.max;
        }
    }
})();